// TODO MR - Unsure how to type a ref - did some of https://medium.com/@martin_hotell/react-refs-with-typescript-a32d56c4d315 but T didn't seem valid due to it being all sorts of objects

export const scrollToRef = (ref, delay = 0) => {
    if (ref.current && ref.current.scrollIntoView) {
        if (delay > 0) {
            // Timeout so that scroll doesn't happen until animation complete
            setTimeout(() => {
                // Because of timeout, still possible for ref to not be there when this runs, so ?. for safety
                ref.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }, delay);
        } else {
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    }
};
